var SPiD = this.SPiD || {};

(function () {
    'use strict';

    SPiD.hasClass = function (el, cn) {
        return new RegExp('(^|\\s)' + cn + '(\\s|$)').test(el.className);
    };

    SPiD.addClass = function (el, cn) {
        if (!el || SPiD.hasClass(el, cn)) {
            return;
        }
        el.className = (el.className + ' ' + cn).trim();
    };

    SPiD.rmClass = function (el, cn) {
        if (!el || !SPiD.hasClass(el, cn)) {
            return;
        }

        var re = new RegExp('(^|\\s)' + cn + '(\\s|$)', 'g');
        el.className = el.className.replace(re, '').replace(/\s\s+/g, ' ').trim();
    };

    SPiD.toggleClass = function (el, cn, condition) {
        if (typeof condition === 'undefined') {
            condition = !SPiD.hasClass(el, cn);
        }
        SPiD[condition ? 'addClass' : 'rmClass'](el, cn);
    };

    SPiD.toggle = function (el, show) {
        if (typeof show === 'undefined') {
            show = SPiD.hasClass(el, 'hidden');
        }
        SPiD[show ? 'rmClass' : 'addClass'](el, 'hidden');
    };

    SPiD.toArray = function (coll) {
        // Manually copy, IE8 chokes when calling Array.prototype.slice with a
        // HTMLCollection object as this
        var arr = [];
        for (var i = 0, l = coll.length; i < l; ++i) {
            arr[i] = coll[i];
        }
        return arr;
    };

    SPiD.findElements = function (parent, selector) {
        return SPiD.toArray(parent.querySelectorAll(selector));
    };

    SPiD.setPath = function setValue(data, pathname, value) {
        var path = pathname.replace(/\]/g, '').split('[');

        if (path.length < 2) {
            data[pathname] = value;
            return;
        }

        for (var i = 0; i < path.length - 1; i++) {
            // Falsy path[i+1] means the last item is blank, which indicates
            // that this is a list, e.g. name[sub][] => {name: {sub: []}} or
            // name[] => {name: []}
            data[path[i]] = data[path[i]] || (!path[i+1] ? [] : {});
            data = data[path[i]];
        }

        if (!path[i]) {
            data.push(value);
        } else {
            data[path[i]] = value;
        }
    };

    SPiD.getPath = function setValue(data, name) {
        var path = name.replace(/\]/g, '').split('[');

        for (var i = 0; i < path.length; i++) {
            if (!data[path[i]]) { return null; }
            data = data[path[i]];
        }

        return data;
    };

    SPiD.zeroPad = function (num) {
        return num < 10 ? '0' + num : num;
    };

    SPiD.val = function (container, selector, value) {
        SPiD.findElements(container, selector).forEach(function (e) {
            e.value = value || '';
        });
    };

}());
